import BlogBox from "../../../../src/elementsWeb/BlogBox/index.js";
import ReactPlayer from 'react-player';
import IDAnimation from "../../../../src/assetsWeb/images/id.mp4";
import * as React from 'react';
export default {
  BlogBox,
  ReactPlayer,
  IDAnimation,
  React
};